export default "__VITE_ASSET__fc5d9b3f__"